const lbaAddGridResource = angular.module('app.lbaAddGridResource', []);

lbaAddGridResource.controller('lbaAddGridResourceCtrl', require('./lbaAddGridResourceCtrl'));
lbaAddGridResource.controller('lbaSaveCallbackCtrl', require('./lbaSaveCallbackCtrl'));
lbaAddGridResource.directive('lbaAddGridResource', require('./lbaAddGridResourceDir'));

export default lbaAddGridResource;



// WEBPACK FOOTER //
// ./src/components/lbaAddGridResource/index.js